<section data-step="6" class="step">
    <div class="newchapter">
        <h1 class="chapter">V. De Aanloopfase </h1>
        <h2 class="chaptersubtitle">Even rustig herpakken voor je gaat betalen</h2>
    </div>

    <div class="row ">
        <div class="twelve columns">
            <h2>Augustus 2022 - Feest!</h2>
            <p>Gefeliciteerd! Je bent afgestudeerd en stopt met lenen. Vanaf dit moment telt je rente door, maar hoef je nog niet terug te betalen tot twee jaar na je afstuderen. Wil je toch al beginnen met aflossen? Dan kun je er voor kiezen om dat nu toch al voor een deel te doen. </p>
        </div>
    </div>
    <div class="row">
    <div class="twelve columns">
            <h2>Prestatiebeurs</h2>
            <p>Bij een feestelijke gebeurtenis horen natuurlijk cadeaus! Heb je je diploma binnen 10 jaar gehaald? Dan wordt je schuld met het label prestatiebeurs op dit moment kwijtgescholden!</p>
        </div>
    </div>

    <div class="row ">
        <div class="twelve columns">
            <h2>Rente <small>(vervolg)</small></h2>
            <p>In deze fase betaal je niet terug, maar telt je rente net als in de opbouwfase door. Het kan dus zijn dat je schuld nu toch hoger wordt, ookal krijg je geen extra geld!</p>
        </div>
    </div>
</section>